module.exports = __webpack_public_path__ + "img/xhs.ab1091bd.png";